<template>
  <div class="whole" flexContainer :style="{height:pub_height+'px'}">
    <div class="button" flexContainer>
      <div flex-1></div>
      <ddbutton class="add_but" @click="openDetails">+上传新封面</ddbutton>
    </div>
    <detail ref="banner_ref" @banner_fun="get_banner"></detail>
    <div class="banner_table">
      <el-table
        :data="tableData"
        :header-cell-style="headerClass"
        :row-class-name="class_name({rowIndex})"
        :height="pub_height-90+'px'"
        stripe
      >
        <el-table-column prop="name" label="名称" width="180"></el-table-column>
        <el-table-column label="封面" width="180">
          <template slot-scope="scope">
            <el-image class="icon" :src="scope.row.picture" :preview-src-list="[scope.row.picture]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上架时间" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | formateChange}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="desc" style="text-align:left" label="描述">
          <template slot-scope="scope">
            <el-popover
              ref="popover"
              placement="top"
              width="400"
              trigger="hover"
              :content="scope.row.desc"
            >
              <span slot="reference" class="org_name_show">{{scope.row.desc}}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="当前状态" width="100">
          <template slot-scope="scope">
            <div>
              <span>{{(scope.row.status == 0)?'显示':'隐藏'}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作" width="100">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                style="width:50px"
                @click="go_status(scope.row.id,scope.row.status)"
              >{{(scope.row.status == 0)?'隐藏':'显示'}}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get_banner, show_banner } from "@/api/banner";
import app from "@/mixin/index";
export default {
  mixins: [app],
  data() {
    return {
      timers: false,
      tableData: []
    };
  },
  components: {
    detail: () =>
      import(/* webpackChunkName: "design" */ "./components/new_banner"),
    ddbutton: () =>
      import(/* webpackChunkName: "design" */ "@/components/button")
  },
  mounted() {
    this.get_banner();
  },
  methods: {
    //改变banner显示隐藏
    go_status(id, status) {
      if (status == 0) {
        status = 1;
      } else {
        status = 0;
      }
      let data = {
        id: id,
        status: status
      };
      show_banner(data)
        .then(res => {
          this.get_banner();
        })
        .catch(error => {});
    },
    openDetails() {
      this.$refs.banner_ref.init();
    },
    get_banner() {
      get_banner()
        .then(res => {
          this.tableData = res.data;
        })
        .catch(error => {});
    }
  },
  computed: mapState(["pub_height"])
};
</script>
<style lang="scss" scoped>
/deep/.el-main {
  flex-direction: column;
}
/deep/.colorLine {
  background-color: #fafcff !important;
}
/deep/.popularLine {
  background-color: #fff !important;
}
@include deep_table;
.whole {
  background-color: $menu-color;
  flex-direction: column;
  .button {
    padding-top: 14px;
    padding-right: 22px;
    .add_but {
      width: 120px;
      @include s-c-w(14, $menu-color, 400);
    }
  }
  .banner_table {
    padding: 14px 30px 20px 30px;
    .icon {
      width: 109px;
      height: 69px;
      margin-top: 9px;
    }
    .org_name_show {
      margin-top: 9px;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      line-height: 23px;
      text-align: left;
    }
    /deep/.el-table__body-wrapper {
      .cell {
        height: 86px;
        line-height: 86px;
      }
      @include s-c-w(14, $text-one, 400);
      .el-table_2_column_5 {
        @include s-c-w(14, $menu-text, 400);
      }
      .el-table_2_column_40 {
        .cell {
          text-align: left !important;
        }
      }
    }
  }
}
</style>